module.exports = __webpack_public_path__ + "static/media/noclass1.798383bc.png";